import { render, staticRenderFns } from "./PazienteEventoTerapiaComponent.vue?vue&type=template&id=37b2a156"
import script from "./PazienteEventoTerapiaComponent.vue?vue&type=script&lang=js"
export * from "./PazienteEventoTerapiaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports